"use client";

import { AlgoliaEvents } from "@entities/algolia";
import { useAlgoliaIndex } from "@entities/algolia";
import { HighlightedText } from "@shared/ui";
import { PinLocationIcon } from "@shared/ui/custom-icon";
import { getSlug, imageFallback } from "@shared/utils";
import { AlgoliaHit } from "instantsearch.js";
import Image from "next/image";
import Link from "next/link";
import { Index, useHits } from "react-instantsearch";

type IndustrialVacancyHit = AlgoliaHit<{
  id: string;
  title: string;
  company_name: string;
  city_name: string;
  company_logo_uri: string;
  platform_type: "internal" | "external";
  platform_name: string;
  platform_logo: string;
}>;

function IndustrialVacancyHits({ onClick }: { onClick: () => void }) {
  const { items, results, sendEvent } = useHits<IndustrialVacancyHit>();

  const handleClick = (hit: IndustrialVacancyHit) => {
    if (onClick) {
      onClick();
    }

    sendEvent("click", hit as any, AlgoliaEvents.INDUSTRIAL_VACANCY_CLICKED);
  };

  if (items.length <= 0) {
    return <></>;
  }

  return (
    <div>
      <h4 className="p-3 font-bold text-lg">Lowongan dalam negeri</h4>
      {items.map((it) => {
        return (
          <Link
            key={it.id}
            href={`/lowongan-dalam-negeri/lowongan/${getSlug(it.id, it.title)}`}
            className="flex items-start hover:bg-gray-200 rounded-lg p-3 gap-3"
            onClick={() => handleClick(it)}
          >
            <Image
              src={it.company_logo_uri || "/blank-white.webp"}
              className="w-12 h-12 min-w-12 rounded-lg bg-gray-100 object-cover border border-gray-200 mt-0.5"
              width="48"
              height="48"
              alt={it.company_name}
              onError={imageFallback()}
            />
            <div className="flex-1">
              <div className="font-semibold text-base">
                {results?.query ? <HighlightedText keyword={results?.query} text={it.title} /> : it.title}
              </div>
              {it.company_name && <div className="mt-1 text-sm">{it.company_name}</div>}
              {it.city_name && (
                <div className="mt-2 text-xs flex items-start gap-1">
                  <PinLocationIcon className="size-3 min-w-3 mt-0.5" />
                  <span className="flex-1">{it.city_name}</span>
                </div>
              )}
            </div>
          </Link>
        );
      })}
    </div>
  );
}

export function AlgoliaIndustrialVacancyResult({ onClick }: { onClick: () => void }) {
  const { industrialVacancy } = useAlgoliaIndex();

  return (
    <Index indexName={industrialVacancy}>
      <IndustrialVacancyHits onClick={onClick} />
    </Index>
  );
}
